<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <!-- <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i> Filter
          </button> -->
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="12">
          <b-input-group>
            <b-input-group-prepend>
              <label style="min-width: 150px" class="text-right">Tgl. Collection Report</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl" type="date" class="ml-3" :max="maxdtreport"
              :state="!$v.tblData.tgl.$error"></b-form-input>
            <b-input-group-append>
              <label style="min-width: 75px" class="pt-2 ml-2 text-right">Project</label>
            </b-input-group-append>
            <b-form-select v-model="tblData.pjxkey" :plain="true" :options="sourceproject"></b-form-select>
            <b-input-group-append>
              <b-button variant="success" @click="getHistoryTrx()" class="ml-3">
                <i class="fa fa-play"></i> Proses
              </b-button>
              <b-button variant="primary ml-2" @click="exportxlsCR()">
                <i class="fa fa-file-excel-o"></i>Export
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-card no-body class="mb-0">
        <b-table class="mb-0" ref="table" outlined responsive striped hover style="font-size: smaller"
          :items="tblData.items" :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy" :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" :filter="filterInput"
          :filterIncludedFields="filterOn" @filtered="onFiltered" :busy="isBusy" show-empty>
          <template v-slot:cell(index)="data">{{ ((tblData.page - 1) * tblData.limit) + (data.index + 1) }}</template>
          <template v-slot:cell(duedate)="data">{{
          data.item.duedate | moment("DD/MM/YY")
        }}</template>
          <template v-slot:cell(PREPAID_LAST_MONTH)="data">{{
          data.item.PREPAID_LAST_MONTH | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(PAYMENT_RECEIVED)="data">{{
          data.item.PAYMENT_RECEIVED | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(PRINCIPAL_AMT)="data">{{
          data.item.PRINCIPAL_AMT | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(INTEREST_AMT)="data">{{
          data.item.INTEREST_AMT | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(LC_RECEIVED)="data">{{
          data.item.LC_RECEIVED | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(OTHER_RECEIVED)="data">{{
          data.item.OTHER_RECEIVED | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(CONTRACT_PREPAID_AMT)="data">{{
          data.item.CONTRACT_PREPAID_AMT | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(DISCOUNT_POKOK)="data">{{
          data.item.DISCOUNT_POKOK | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(principal_outstand)="data">{{
          data.item.principal_outstand | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(OS_PRINCIPAL_TOTAL_AMT)="data">{{
          data.item.OS_PRINCIPAL_TOTAL_AMT | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(OS_INTEREST_TOTAL_AMT)="data">{{
          data.item.OS_INTEREST_TOTAL_AMT | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(DAYS_OVER_DUE)="data">{{
          data.item.DAYS_OVER_DUE | numFormat("0,0")
        }}</template>
          <template v-slot:cell(saldo_interest)="data">{{
          data.item.saldo_interest | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(OS_PRINCIPAL_DUE_AMT)="data">{{
          data.item.OS_PRINCIPAL_DUE_AMT | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(OS_INTEREST_DUE_AMT)="data">{{
          data.item.OS_INTEREST_DUE_AMT | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(saldo_latecharge)="data">{{
          data.item.saldo_latecharge | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(OS_LC_TOTAL_AMT)="data">{{
          data.item.OS_LC_TOTAL_AMT | numFormat("0,0.00")
        }}</template>

          <template v-slot:cell(rrd_date)="data">{{
          data.item.rrd_date | moment("DD/MM/YY")
        }}</template>
          <template v-slot:cell(JUMLAH_BULAN_TERTUNGGAK)="data">{{
          data.item.JUMLAH_BULAN_TERTUNGGAK | numFormat("0,0")
        }}</template>
          <template v-slot:cell(RRD_DT)="data">{{
          data.item.RRD_DT | moment("DD/MM/YY")
        }}</template>
          <template v-slot:cell(NEXT_INST_DT)="data">{{
          data.item.NEXT_INST_DT | moment("DD/MM/YY")
        }}</template>
          <template v-slot:cell(NEXT_INST_NUM)="data">{{
          data.item.NEXT_INST_NUM | numFormat("0,0")
        }}</template>
        <template v-slot:cell(ttl_payment_after_cessie)="data">{{
          data.item.ttl_payment_after_cessie | numFormat("0,0")
        }}</template>
        
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>

        </b-table>
      </b-card>
      <b-row class="m-1">
        <b-col lg="6">
          <b-row v-if="(filterShow == 'Hide')">
            <b-input-group size="sm">
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
              <b-input-group-prepend> <span class="pr-2">
                  <b> {{ filterShow }}</b> Filter </span>
              </b-input-group-prepend>
              <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
            <b-input-group size="sm" class="ml-4">
              <b-input-group-prepend class="ml-5"> <span class="pr-2">On</span>
              </b-input-group-prepend>
              <b-form-checkbox-group v-model="filterOn" class="mt-1">
                <b-form-checkbox value="no_agreement">Agreement No.</b-form-checkbox>
                <b-form-checkbox value="CustName">Debitur Name</b-form-checkbox>
                <b-form-checkbox value="KOL_EOM">Collectability</b-form-checkbox>
                <b-form-checkbox value="DefaultStat">Default (WO) status</b-form-checkbox>
              </b-form-checkbox-group>
            </b-input-group>
            <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
          </b-row>
          <b-row v-else>
            <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
              <b> {{ filterShow }}</b> Filter
            </b-form-checkbox>
          </b-row>
        </b-col>
        <b-col lg="6">
          <div style="display: flex;margin:0;padding:0;">
            <div style="margin:0;padding:5px;width:500px; text-align:right;">
              Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
              to <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span> <span
                v-else>{{ tblData.page * tblData.limit }}</span>
              of {{ tblData.total }} , <span class="mr-1">limit per page :</span>
              <select v-model="tblData.limit" style="width:60px;">
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
                <option>40</option>
                <option>50</option>
                <option>60</option>
                <option>70</option>
                <option>80</option>
                <option>90</option>
              </select>
            </div>
            <div>
              <b-pagination class="ml-1" align="left" :total-rows="tblData.total" :per-page="tblData.limit"
                v-model="tblData.page"></b-pagination>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isBusy" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { validationMixin } from "vuelidate";
import moment from "moment";
import myNumber from "../../components/my-number";
import toastr from "mini-toastr";
import pinjaman from "../../apis/pinjamankredit";
import project from "../../apis/project";

toastr.init();
export default {
  components: { myNumber, Loading },
  mixins: [validationMixin],
  validations: {
    tblData: {
      tgl: {
        required: function () {
          let tgl = this.tblData.tgl;
          let admin = this.tblData.admin;
          if (admin) {
            return true;
          } else {
            if ((tgl || '') == "") {
              return true;
            } else if (moment(tgl).diff(this.timeServer, 'days') < 1) {
              return true;
            } else {
              return false;
            }
          }

        }
      }
    }
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      maxdtreport: '',
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "no_kontrak",
        sortDesc: false,
        tgl: '',
        admin: 0,
        pjxkey: '',
        pjxname:''
      },
      sourceproject: [],
      filterShow: 'Show',
      filter: null,
      filterInput: null,
      filterOn: ['no_agreement', 'CustName'],
    };
  },
  computed: {
    invalidTblData() {
      this.$v.tblData.$touch();
      return this.$v.tblData.$invalid;
    },
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "#",
          thStyle: "width:140px",
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true,
        },
        {
          key: "no_agreement",
          label: "No. Agreement",
          thStyle: "width:140px",
          sortable: true,
        },
        {
          key: "duedate",
          label: "Maturity",
          thStyle: "width:190px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "PREPAID_LAST_MONTH",
          label: " PREPAID_LAST_MONTH",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "PAYMENT_RECEIVED",
          label: "Payment Received",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "PRINCIPAL_AMT",
          label: "PRINCIPAL_AMT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "INTEREST_AMT",
          label: "INTEREST_AMT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "LC_RECEIVED",
          label: "LC_RECEIVED",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "OTHER_RECEIVED",
          label: "Other Received",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "CONTRACT_PREPAID_AMT",
          label: "CONTRACT_PREPAID_AMT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "DISCOUNT_POKOK",
          label: "Discount Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "OS_PRINCIPAL_TOTAL_AMT",
          label: "OS_PRINCIPAL_TOTAL_AMT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "DAYS_OVER_DUE",
          label: "DOD",
          thClass: "text-center",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "KOL_EOM",
          label: "Kol EOM",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "OS_INTEREST_TOTAL_AMT",
          label: "OS_INTEREST_TOTAL_AMT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "OS_PRINCIPAL_DUE_AMT",
          label: "OS_PRINCIPAL_DUE_AMT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "OS_INTEREST_DUE_AMT",
          label: "OS_INTEREST_DUE_AMT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "OS_LC_TOTAL_AMT",
          label: "OS_LC_TOTAL_AMT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "pjxname",
          label: "OFFICE_NAME",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "RRD_DT",
          label: "RRD Date",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "JUMLAH_BULAN_TERTUNGGAK",
          label: "JUMLAH_BULAN_TERTUNGGAK",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        }, {
          key: "ANGSURAN_TERTUNGGAK_KE_SD_KE",
          label: "ANGSURAN_TERTUNGGAK_KE_SD_KE",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        }, {
          key: "NEXT_INST_DT",
          label: "NEXT_INST_DT",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        }, {
          key: "NEXT_INST_NUM",
          label: "NEXT_INST_NUM",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        }, {
          key: "NEXT_INST_DUE_NUM",
          label: "NEXT_INST_DUE_NUM",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        }, {
          key: "contract_stat",
          label: "contract_stat",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "tenor",
          label: "Tenor (Bulan)",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        // {
        //   key: "refund",
        //   label: "Refund",
        //   thStyle: "width:140px",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   sortable: true,
        // },
        {
          key: "ttl_payment_after_cessie",
          label: "Ttl. Payment\n(After Cessie)",
          thStyle: "width:240px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      ];


      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
    user() {
      return this.$store.state.user;
    },
    timeServer() {
      return moment(this.$store.state.timeServer[this.user.compcode]).format('YYYY-MM-DD');
    },
    route() {
      return this.$route;
    }
  },
  watch: {
    filterShow: function (newval) {
      setTimeout(() => {
        this.filter = ''
      }, 200);
    },
    filter: function (newval) {
      // this.isBusy=true;
      setTimeout(() => {
        this.filterInput = newval;
      }, 800);
    },
    'tblData.pjxkey': function (newval) {
      const obj = this.sourceproject.find(x=>x.value == newval);
      this.tblData.pjxname = obj.pjxname || '';
    }
  },
  async created() {
    try {
      this.tblData.tgl = moment(this.$store.state.timeServer[this.user.compcode]).format('YYYY-MM-DD');
      this.maxdtreport = moment(this.$store.state.timeServer[this.user.compcode]).format('YYYY-MM-DD');
      if (this.route.name == "loan.admin-collection-report") {
        this.tblData.admin = 1;
      }
      const projectDt = await project.listbyuser();
      this.sourceproject = projectDt.map(item=>{
        item.value= item.pjxkey;
        item.text= item.pjxname;
        return item
      })
            
      if(this.sourceproject.length==1) this.tblData.pjxkey = this.sourceproject[0].value

    } catch (error) {
      toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    clearFilter() {
      //this.filterOn= []   
      this.filter = '';
    },

    async getHistoryTrx() {
      try {
        if (!this.invalidTblData) {
          this.isBusy = true;
          const list = await pinjaman.colectabilityreport(this.tblData);
          this.isBusy = false;
          this.tblData.items = list;
          this.tblData.total = list.length;
        }
      } catch (error) {
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async exportxlsCR() {
      try {
        if (!this.invalidTblData) {
          this.isBusy = true;
          await pinjaman.exportxlsCR(this.tblData);
          this.isBusy = false;
        }
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>